import { motion } from 'framer-motion';
import { useEffect } from 'react';

import CrossIcon from '../icons/CrossIcon';

export default function PhotoLightbox({
  photo,
  hasPrev,
  hasNext,
  onPrev,
  onNext,
  onClose,
}) {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
      else if (e.key === 'ArrowLeft' && hasPrev) onPrev();
      else if (e.key === 'ArrowRight' && hasNext) onNext();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onClose, onPrev, onNext, hasPrev, hasNext]);

  return (
    <motion.div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 select-none"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose}
    >
      <motion.div
        className="relative max-w-full max-h-full flex items-center justify-center"
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        transition={{ type: 'spring', duration: 0.4 }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute -top-3 -right-3 z-20 bg-white rounded-full p-1.5 shadow-lg text-gray-700 hover:text-gray-900 focus:outline-none"
          aria-label="Close"
        >
          <CrossIcon className="w-5 h-5" />
        </button>

        {hasPrev && (
          <button
            onClick={onPrev}
            className="absolute left-2 sm:left-4 z-20 bg-white/80 hover:bg-white text-gray-800 rounded-full p-2.5 shadow-lg transition-transform hover:scale-110 focus:outline-none"
            aria-label="Previous image"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
        )}

        <img
          key={photo.id}
          src={photo.original_url}
          alt="Guest upload"
          className="max-w-[92vw] max-h-[88vh] rounded-xl object-contain shadow-2xl"
        />

        {hasNext && (
          <button
            onClick={onNext}
            className="absolute right-2 sm:right-4 z-20 bg-white/80 hover:bg-white text-gray-800 rounded-full p-2.5 shadow-lg transition-transform hover:scale-110 focus:outline-none"
            aria-label="Next image"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        )}
      </motion.div>
    </motion.div>
  );
}
